module.exports = __webpack_public_path__ + "img/VidaAnimal.54cbc87b.png";